let inject = ['$scope' ,'$sce', '$uibModalInstance','modalOptions'];

class ModalVideoController {
  constructor ($scope,$sce,$uibModalInstance,modalOptions) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$sce=$sce;
    this.modalOptions = Object.assign({}, modalOptions);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
  trustedUrl(url){
    return this.$sce.trustAsResourceUrl(url);
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalVideoController.$inject = inject;

export default ModalVideoController;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/modal-video/modal-video.controller.js
 **/